export const carriersList = [
  { id: '6910012', name: 'THE HAYLOCK FAMILY TRUST' },
  { id: '6910016', name: 'TOLL MINING SERVICES (MW) PTY LTD' },
  { id: '6910020', name: 'THE TRUSTEE FOR STEVEMACS TRUST' },
  { id: '6910034', name: 'The Trustee for A G & P F MCWHIRTER' },
  { id: '6910051', name: 'THE KILPATRICK TRUST' },
];

export const getCarrierNameById = (id) => {
  const carrier = carriersList.find((carrier) => carrier.id === id);
  return carrier ? carrier.name : null;
}